export const AUTH_LOGIN = 'AUTH_LOGIN';
export const AUTH_AUTOLOGIN = 'AUTH_AUTOLOGIN';
export const AUTH_LOGOUT = 'AUTH_LOGOUT';
